module.exports = __webpack_public_path__ + "static/media/as.cb630927.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/as.svg
// module id = 52
// module chunks = 0